import "./modules/predictive-search";
import AOS from 'aos'
import EmblaCarousel from 'embla-carousel'
import AutoHeight from 'embla-carousel-auto-height'
import { addPrevNextBtnsClickHandlers } from './modules/emblaArrows'
import SlimSelect from 'slim-select'

// import { addDotBtnsAndClickHandlers } from './modules/EmblaDots'
// import { setupProgressBar } from './modules/emblaProgress'
// import { updateSelectedSnapDisplay } from './modules/emblaSelectedSnapDisplay'




AOS.init({
	duration: 900,
	once: true
});

// Set Viewport Width (vw) Variable
new ResizeObserver(function(){
	let vw = document.documentElement.clientWidth / 100;
	document.documentElement.style.setProperty('--vw', vw + 'px');
}).observe(document.documentElement);


// Sticky header
const headerEl = document.querySelector('#site-header');
const sentinelEl = document.querySelector('#header-sentinel');
const handler = (entries) => {
	if (!entries[0].isIntersecting) {
		headerEl.classList.add('sticky-header');
	} else {
		headerEl.classList.remove('sticky-header');
	}
}
const observer = new window.IntersectionObserver(handler);
document.addEventListener("DOMContentLoaded", function() {
	observer.observe(sentinelEl);
});

// Fade in/out back to top button
const bttEl = document.querySelector('#back-to-top');
const bttSentinelEl = document.querySelector('#back-to-top-sentinel');
const bttHandler = (entries) => {
	if (!entries[0].isIntersecting) {
		bttEl.classList.add('is-displayed');
	} else {
		bttEl.classList.remove('is-displayed');
	}
}
const bttobserver = new window.IntersectionObserver(bttHandler);
document.addEventListener("DOMContentLoaded", function() {
	bttobserver.observe(bttSentinelEl);
});


// Slim select
if(document.getElementById('advanced-search')) {
	const selectChanged = new CustomEvent("slimchanged");
	document.querySelectorAll('#advanced-search select').forEach((el)=>{
		const sss = new SlimSelect({
		  select: el,
		  settings: {
			showSearch: true
		  },
		  events: {
			  afterChange: () => {
				  el.dispatchEvent(selectChanged);
			  }
		  }
		});
	});
}

// Scrollspy
var dontSpy = false;
var scrollTimeout;

if(document.querySelector('.sticky-nav-target')) {
	function anchorObserverCallback(entries, observer){
		entries.forEach((entry) => {
			const activeItems = document.querySelectorAll('.sticky-subnav-bar li a[href="#' + entry.target.id + '"]');
			if(entry.isIntersecting && !dontSpy) {
				document.querySelectorAll('.sticky-subnav-bar li a').forEach(el => {
					el.classList.remove('active');
				});
				activeItems.forEach(el => {
					el.classList.add('active');
				});
			}
		});
	}
	const anchorObserver = new IntersectionObserver(anchorObserverCallback, {rootMargin: "-50% 0px"});
	document.querySelectorAll('.sticky-nav-target').forEach(el => {
		anchorObserver.observe(el);
	});
}

const anchorLinks = document.querySelectorAll('.sticky-subnav-bar li a');
anchorLinks.forEach(lnk => {
	lnk.addEventListener('click', () => {
		clearTimeout(scrollTimeout);
		dontSpy = true;
		document.querySelectorAll('.sticky-subnav-bar li a').forEach(el => {
			el.classList.remove('active');
		});
		lnk.classList.add('active');
		scrollTimeout = setTimeout(() => {
			dontSpy = false;
		}, 1000);
	});
});


const infinityScrollHandler = (entries) => {
	if (entries[0].isIntersecting) {
		entries[0].target.click();
	}
}
const infinityScrollObserver = new window.IntersectionObserver(infinityScrollHandler);


// Insights landing: move advanced search to hero on responsive
function responsiveInsightsFilter() {
	if(jQuery('.hero-insights').length) {
		if (jQuery(window).width() < 1200) {
			jQuery('.insights-search-form').appendTo('.hero .hero-content');

			if (jQuery(window).width() < 768) {
				jQuery('.advanced-search-wrap').prependTo('.posts-landing-band .container-xxl');
			} else {
				jQuery('.advanced-search-wrap').appendTo('.hero .hero-content');
			}
		} else {
			jQuery('.insights-search-form').prependTo('.insights-subnav-bar .container-xxl');
			jQuery('.advanced-search-wrap').prependTo('.posts-landing-band .container-xxl');
		}
	}
}




jQuery(function($){
	responsiveInsightsFilter();
	$(window).on('resize', responsiveInsightsFilter);


	if(document.querySelector('.infinity-scroll-btn-wrap a')) {
		infinityScrollObserver.observe(document.querySelector('.infinity-scroll-btn-wrap a'));
	}
	
	// Widget close button
	$('.widget-close-btn').on('click', function(event){
		event.preventDefault();
		let widget = $(this).closest('.widget');
		widget.stop().fadeOut();
	});

	// Play/pause bg video btn
	$('.video-control-btn').on('click', function(e){
		e.preventDefault();
		if($(this).hasClass('paused')) {
			$('.bg-video video')[0].play();
		} else {
			$('.bg-video video')[0].pause();
		}
		$(this).toggleClass('paused').find('i').toggleClass('fa-pause-circle fa-play-circle');
	});

	// Hide advanced search on phone
	if ($(window).width() < 768) {
		$('#advanced-search').collapse('hide');
	}

	// Mobile header
	$('.mobile-menu-toggle').on('click', function(e){
		e.preventDefault();
		$('body').toggleClass('mobile-menu-expanded');
		$('.header-content').fadeToggle(300);
	});

	// Email disclaimer popup
	$('.email-link').click(function(e){
		e.preventDefault();
		let disclaimerModal = $('#email-disclaimer');
		let emailAddress = $(this).data('email');
		let emailCCAddress = $(this).data('cc');
		let emailSubject = $(this).data('subject');

		let confirmHref = 'mailto:' + emailAddress;
		if( emailCCAddress ){
			confirmHref += '?cc=' + emailCCAddress;
		}
		if( emailSubject ){
			let concatChar = emailCCAddress ? '&' : '?';
			confirmHref += concatChar+'subject=' + emailSubject;
		}

		disclaimerModal.find('.confirm-link').attr('href', confirmHref);
		disclaimerModal.modal('show');
	});
	
	$('#email-disclaimer .confirm-link').on('click', function(e){
		let disclaimerModal = $('#email-disclaimer');
		disclaimerModal.modal('hide');
	});

	// Jump to next section
	$('.home-hero-band .scroll-to-next').on('click', function(e){
		e.preventDefault();
		document.querySelector('.home-hero-band + *').scrollIntoView({behavior: "smooth"});
	});

	// Load more extended content
	$('.breaker-toggle').on('click', function(e){
		e.preventDefault();
		let extContent = $(this).closest('.button-wrap').prev('.extended-content');
		$(this).closest('.button-wrap').remove();
		extContent.fadeIn(250);
	});

	$('.breaker-posts-list-toggle').on('click', function(e){
		e.preventDefault();
		let extContent = $(this).closest('.button-wrap').prev('.posts-list').find('li');
		$(this).closest('.button-wrap').remove();
		extContent.fadeIn(250);
	});

	// Sticky subnav click
	$('.subnav-links .embla__slide a').on('click', function(e){
		e.preventDefault();
		let target = $(this).attr('href');
		document.querySelector(target).scrollIntoView({behavior: "smooth"});
		window.history.replaceState('', '', target);
	});

	// Ajax form
	$('.ajax-form').on('submit', function(e){
		e.preventDefault();
		let target = $(this).attr('action');
		let holderSelector = '#ajax-holder';
		let holder = $(holderSelector);
		let fieldsData = $(this).find("input").filter(function() {
			return $.trim(this.value).length > 0
		}).serialize();
		if(fieldsData) {

			holder.addClass('is-loading');
			target = target + '?' + fieldsData;
			window.history.replaceState('', '', target);
			$('.ajax-filter-btns .embla__slide a').removeClass('is-active');
			$('.subnav-bar .clear-filter-btn').addClass('is-active');

			$.get(target, function(response){
				let entries = $(response).find(holderSelector).children();
				holder.html(entries).removeClass('is-loading');
				$('.attorneys-listing-band').addClass('is-filtered');
				if(document.querySelector('.infinity-scroll-btn-wrap a')) {
					infinityScrollObserver.observe(document.querySelector('.infinity-scroll-btn-wrap a'));
				}
			});
		}
	});

	// Ajax alpha sort
	$('.ajax-filter-btns .embla__slide a').on('click', function(e){
		e.preventDefault();

		$('.ajax-filter-btns .embla__slide a').removeClass('is-active');
		$(this).addClass('is-active');
		let target = $(this).attr('href');
		let holderSelector = '#ajax-holder';
		let holder = $(holderSelector);
		$('.search-form.attorney-search, .search-form.service-search').removeClass('search-done').find('.keyword').val('');
		$('.subnav-bar .clear-filter-btn').addClass('is-active');
		holder.addClass('is-loading');

		$.get(target, function(response){
			let entries = $(response).find(holderSelector).children();
			holder.html(entries).removeClass('is-loading');
			window.history.replaceState('', '', target);
			$('.attorneys-listing-band').addClass('is-filtered');
		});
	});

	function closeMobileAdvancedSearch() {
		if($(window).width() < 768) {
			$('#advanced-search').collapse('hide');
		}
	}
	$('.close-adv-search').on('click', closeMobileAdvancedSearch);
	$('#advanced-search').on('show.bs.collapse', function(){
		$('body').addClass('advanced-search-active');
	});
	$('#advanced-search').on('hide.bs.collapse', function(){
		$('body').removeClass('advanced-search-active');
	});

	// Clear filter on attorneys & services page
	$('.subnav-bar .clear-filter-btn').on('click', function(e){
		e.preventDefault();
		$('.ajax-form .keyword').val('');
		let target = $(this).data('target');
		let holderSelector = '#ajax-holder';
		let holder = $(holderSelector);
		$(this).removeClass('is-active');
		$('.search-form.attorney-search, .search-form.service-search').removeClass('search-done').find('.keyword').val('');
		$('.ajax-filter-btns .embla__slide a').removeClass('is-active');
		holder.addClass('is-loading');

		$.get(target, function(response){
			let entries = $(response).find(holderSelector).children();
			holder.html(entries).removeClass('is-loading');
			window.history.replaceState('', '', target);
			//$('.attorneys-listing-band').removeClass('is-filtered');
			if(document.querySelector('.infinity-scroll-btn-wrap a')) {
				infinityScrollObserver.observe(document.querySelector('.infinity-scroll-btn-wrap a'));
			}
		});

	});


	// Ajax more
	var isFetching = false;
	$('#ajax-holder').on('click', '.ajax-more-btn-wrap a', function(e){
		e.preventDefault();
		if(!isFetching) {
			isFetching = true;
			let target = $(this).attr('href');
			let holderSelector = '#ajax-holder';
			let holder = $(holderSelector);
			let thisBtnWrap = $(this).closest('.ajax-more-btn-wrap');

			thisBtnWrap.addClass('is-loading');
			$.get(target, function(response){
				thisBtnWrap.remove();
				let entries = $(response).find(holderSelector).children();
				holder.append(entries);
				isFetching = false;
				if(document.querySelector('.infinity-scroll-btn-wrap a')) {
					infinityScrollObserver.observe(document.querySelector('.infinity-scroll-btn-wrap a'));
				}
			});
		}
	});

	// Insights filters
	$('.insight-cat-btns .embla__slide button').on('click', function(e){
		e.preventDefault();
		let slug = "";
		if( $(this).hasClass('is-active') == false ){
			slug = $(this).data('slug');
		}
		$('.advanced-search-form select.sync-to-btns')[0].slim.setSelected(slug);
	});
	$('.advanced-search-form select').on('slimchanged', function(){
		let value = $(this).val();
		
		if( value ){
			$(this).addClass('ss-has-value');
		} else {
			$(this).removeClass('ss-has-value');
		}
		
		if($(this).hasClass('sync-to-btns')) {	
			$('.insight-cat-btns .embla__slide button').removeClass('is-active');
			if( value ){
				$('.insight-cat-btns .embla__slide button[data-slug="' + value + '"]').addClass('is-active');
			}
		}

		if($(window).width() > 767) {
			$('.advanced-search-form').submit();
		}
	});
	$('.advanced-search-form').on('submit', function(e){
		e.preventDefault();
		closeMobileAdvancedSearch();
		let masterForm = $('.insights-search-form');
		$('.advanced-search-form select').each(function() {
			let value = $(this).val();
			let name = $(this).attr('name');
			masterForm.find('input[name="' + name + '"]').val(value);
		});
		masterForm.submit();
	});
	$('.clear-all-filter').on('click', function(){
		$('.insights-search-form .keyword').val('');
		$('.advanced-search-form .ss-has-value').removeClass('ss-has-value');
		$('.advanced-search-form select').each(function(e){
			this.slim.setSelected('', false);
		});
		$('.insight-cat-btns .embla__slide button').removeClass('is-active');
		$('.advanced-search-form').submit();
		$('.clear-all-filter').removeClass('is-active');
	});
	$('.insights-search-form').on('submit', function(e) {
		e.preventDefault();
		let target = $(this).attr('action');
		let holderSelector = '#ajax-holder';
		let holder = $(holderSelector);
		let fieldsData = $(this).find("input").filter(function() {
			return $.trim(this.value).length > 0
		}).serialize();
		if(fieldsData) {
			target = target + '?' + fieldsData;
			$('button.clear-all-filter').addClass('is-active');
		}

		holder.addClass('is-loading');
		window.history.replaceState('', '', target);

		$.get(target, function(response){
			let entries = $(response).find(holderSelector).children();
			holder.html(entries).removeClass('is-loading');
			if(document.querySelector('.infinity-scroll-btn-wrap a')) {
				infinityScrollObserver.observe(document.querySelector('.infinity-scroll-btn-wrap a'));
			}
		});
	});
	$('.posts-landing-row').on('click', '.ajax-pagination a', function(e){
		e.preventDefault();
		let target = $(this).attr('href');
		let holderSelector = '#ajax-holder';
		let holder = $(holderSelector);

		holder.addClass('is-loading');
		document.querySelector('.subnav-bar').scrollIntoView({behavior: "smooth"});
		$.get(target, function(response){
			let entries = $(response).find(holderSelector).children();
			holder.html(entries).removeClass('is-loading');
			if(document.querySelector('.infinity-scroll-btn-wrap a')) {
				infinityScrollObserver.observe(document.querySelector('.infinity-scroll-btn-wrap a'));
			}
		});
	});


});

// Slider: Quote Carousel
const quotesSlider = document.querySelectorAll(".quote-carousel");
quotesSlider.forEach((emblaNode) => {
	const viewportNode = emblaNode.querySelector('.embla__viewport');
	const prevBtnNode = emblaNode.querySelector('.embla__button--prev');
	const nextBtnNode = emblaNode.querySelector('.embla__button--next');

	// Shuffle first
	const containerNode = emblaNode.querySelector('.embla__container');
	const slides = Array.from(containerNode.children);
	for (let i = slides.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [slides[i], slides[j]] = [slides[j], slides[i]]; // Swap elements
    }
	slides.forEach(div => containerNode.appendChild(div));

	const OPTIONS = {
		loop: true,
	};

	const emblaApi = EmblaCarousel(viewportNode, OPTIONS, [AutoHeight()]);

	const removePrevNextBtnsClickHandlers = addPrevNextBtnsClickHandlers(
	  emblaApi,
	  prevBtnNode,
	  nextBtnNode
	);

	emblaApi
		.on('destroy', removePrevNextBtnsClickHandlers);

});

// Slider: News
const newsSlider = document.querySelectorAll(".news-carousel-band");
newsSlider.forEach((emblaNode) => {
	const viewportNode = emblaNode.querySelector('.embla__viewport');
	const prevBtnNode = emblaNode.querySelector('.embla__button--prev');
	const nextBtnNode = emblaNode.querySelector('.embla__button--next');

	const OPTIONS = {
		align: 'start',
		loop: false,
	};

	const emblaApi = EmblaCarousel(viewportNode, OPTIONS);

	const removePrevNextBtnsClickHandlers = addPrevNextBtnsClickHandlers(
	  emblaApi,
	  prevBtnNode,
	  nextBtnNode
	);

	emblaApi
		.on('destroy', removePrevNextBtnsClickHandlers);

});

// Slider: Events Pill
const pillSlider = document.querySelectorAll(".pills-mobile-carousel");
pillSlider.forEach((emblaNode) => {
	const viewportNode = emblaNode.querySelector('.embla__viewport');
	const prevBtnNode = emblaNode.querySelector('.embla__button--prev');
	const nextBtnNode = emblaNode.querySelector('.embla__button--next');

	const OPTIONS = {
		align: 'start',
		loop: false,
		breakpoints: {
			'(min-width: 768px)': {
				active: false,
			}
		}
	};

	const emblaApi = EmblaCarousel(viewportNode, OPTIONS);

	const removePrevNextBtnsClickHandlers = addPrevNextBtnsClickHandlers(
	  emblaApi,
	  prevBtnNode,
	  nextBtnNode
	);

	emblaApi
		.on('destroy', removePrevNextBtnsClickHandlers);

});



// Subnav / orangebar scroll
const navSlider = document.querySelectorAll(".subnav-carousel");
navSlider.forEach((emblaNode) => {
	const viewportNode = emblaNode.querySelector('.embla__viewport');
	const prevBtnNode = emblaNode.querySelector('.embla__button--prev');
	const nextBtnNode = emblaNode.querySelector('.embla__button--next');

	const OPTIONS = {
		dragFree: true,
		slides: '.embla__slide',
		align: 'start',
		breakpoints: {
			'(min-width: 1201px)': {
				active: false,
			//	slides: '.embla__slide:not(.mobile-slide)',

			}
		}
	};

	const emblaApi = EmblaCarousel(viewportNode, OPTIONS);

	const removePrevNextBtnsClickHandlers = addPrevNextBtnsClickHandlers(
	  emblaApi,
	  prevBtnNode,
	  nextBtnNode
	);

	// Prevent Bouncing on overscroll
	/* emblaApi.on("scroll", emblaApi => {
	  const {
		limit,
		target,
		location,
		offsetLocation,
		scrollTo,
		translate,
		scrollBody
	  } = emblaApi.internalEngine()

	  let edge = null

	  if (location.get() >= limit.max) edge = limit.max
	  if (location.get() <= limit.min) edge = limit.min

	  if (edge !== null) {
		offsetLocation.set(edge)
		location.set(edge)
		target.set(edge)
		translate.to(edge)
		translate.toggleActive(false)
		scrollBody.useDuration(0).useFriction(0)
		scrollTo.distance(0, false)
	  } else {
		translate.toggleActive(true)
	  }
	}); */


	emblaApi
		.on('destroy', removePrevNextBtnsClickHandlers);

});


